import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const HighlightPageImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '568',
    width: 568,
    height: 379,
    ratio: 1.5,
  },
  {
    screen: Screen.XS,
    key: '768',
    width: 768,
    height: 512,
    ratio: 1.5,
  },
  {
    screen: Screen.SM,
    key: '1024',
    width: 1024,
    height: 683,
    ratio: 1.5,
  },
];
